import { initPaymentLinkDelivery } from 'application/payment-link-delivery'
// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import {
  initCategories as initSharedCategories,
  initSearchPopup,
  initCookie,
  initCopyButtons
} from 'application/shared'

import { initHeader, initViewportController } from 'application/layouts'
import {
  initMainTags,
  initSlider,
  initSlideBottom,
  initDropdowns,
  initModals,
  initDateInputs,
  initPasswordFields,
  initPhoneInputs,
  initAccordions,
  initSelectFields,
  initTextFields
} from 'application/ui'

import {
  initBlog,
  initTimetable,
  initBooking,
  initBookingPaymentReturn,
  initFeedbackForm,
  initReviews,
  initCategories,
  initQuestSliders,
  initCatalog,
  initQuestsMapPage,
  initQuestSchedule,
  initHelperCardForm,
  initAdultWarning,
  initQuestAttentionTooltips,
  initQuestVideos
} from 'application/quests'

import {
  initSearchPage,
  initAuthPage,
  initFaqPage,
  initContactsForm,
  initCertificatesPage,
  initCartPage,
  initProfilePage,
  initLkOrdersPage,
  initShareButtons,
  initInvoicePreview,
  initGameFeedbackForm
} from 'application/pages'
import { initBlogPage } from 'application/blog'
import { initCategoriesPage } from 'application/categories'
import { initEventServiceSuggestions } from 'application/shared/event-service-suggestions'
import { initGoalClicks, sendEvent } from 'application/utils/analytics'

window.sendEvent = sendEvent

document.addEventListener('DOMContentLoaded', () => {
  initPaymentLinkDelivery()
  initGoalClicks()
  initViewportController()
  initHeader()
  initMainTags()
  initSlider()
  initSlideBottom()
  initDropdowns()
  initSharedCategories()
  initBlog()
  initTimetable()
  initSearchPopup()
  initCatalog()
  initHelperCardForm()
  initQuestsMapPage()
  initSearchPage()
  initModals()
  initAdultWarning()
  initBooking()
  initBookingPaymentReturn()
  initReviews()
  initFeedbackForm()
  initCategories()
  initQuestSliders()
  initQuestVideos()
  initQuestSchedule()
  initQuestAttentionTooltips()
  initPasswordFields()
  initTextFields()
  initDateInputs()
  initPhoneInputs()
  initAuthPage()
  initBlogPage()
  initAccordions()
  initFaqPage()
  initContactsForm()
  initCookie()
  initCertificatesPage()
  initSelectFields()
  initCartPage()
  initProfilePage()
  initLkOrdersPage()
  initCopyButtons()
  initShareButtons()
  initInvoicePreview()
  initGameFeedbackForm()
  initCategoriesPage()
  initEventServiceSuggestions()
})
